import React from "react";
import { Modal, Button, Form, Alert, Spinner } from "react-bootstrap";

export default function YearsModal({
  handleClose,
  show,
  addYear,
  errorMessage,
  loader,
  year,
  duplicatePlvs,
  duplicatePlvTypes,
  duplicateOperationsTypes,
  duplicateComToolTypes,
  duplicatePrestataires,
  duplicateKams,
  duplicateAmbassadrices,
  setDuplicatePlvs,
  setDuplicatePlvTypes,
  setDuplicateOperationsTypes,
  setDuplicateComToolTypes,
  setDuplicatePrestataires,
  setDuplicateKams,
  setDuplicateAmbassdrices,
}) {
  return (
    <Modal show={show} size="lg" onHide={() => handleClose()} centered>
      <Modal.Header closeButton>
        <Modal.Title>Ajouter une année</Modal.Title>
      </Modal.Header>

      <Form
        onSubmit={(e) => {
          e.preventDefault();
          addYear();
        }}
      >
        <Modal.Body>
          {loader ? (
            <div className="text-center pt-5">
              <Spinner animation="border" role="status"></Spinner>
              <div>
                Vous allez recevoir un email lorque ce sera terminé, cette
                opération peut durer quelques minutes...
              </div>
            </div>
          ) : (
            <>
              <Form.Group className="mb-3" controlId="formBasicYear">
                <Form.Label>Année</Form.Label>
                <Form.Control
                  type="number"
                  required
                  autoFocus
                  value={year}
                  disabled={true}
                  /* onChange={(e) => {
                      handleInputChange(e);
                      setYear(e.target.value);
                    }} */
                  placeholder="Entrée une année"
                  name="year"
                  min={new Date().getFullYear() + 1}
                />
              </Form.Group>
              {errorMessage && (
                <div className="col-md-12 m-3 text-center">
                  <Alert variant="danger" className="m-0">
                    {errorMessage}
                  </Alert>
                </div>
              )}
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  checked={duplicatePlvs}
                  readOnly
                  label="Dupliquer les types de plv"
                  onClick={() => {
                    if (duplicatePlvs === true && duplicatePlvTypes === true) {
                      setDuplicatePlvTypes(false);
                    }
                    setDuplicatePlvs(duplicatePlvs ? false : true);
                  }}
                />
              </Form.Group>
              {duplicatePlvs === true && (
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    checked={duplicatePlvTypes}
                    readOnly
                    label="Dupliquer les plvs des clients"
                    onClick={() => {
                      setDuplicatePlvTypes(duplicatePlvTypes ? false : true);
                    }}
                  />
                </Form.Group>
              )}
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  checked={duplicateOperationsTypes}
                  readOnly
                  label="Dupliquer les opérations types"
                  onClick={() => {
                    setDuplicateOperationsTypes(
                      duplicateOperationsTypes ? false : true
                    );
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  checked={duplicateComToolTypes}
                  readOnly
                  label="Dupliquer les outils de communication"
                  onClick={() => {
                    setDuplicateComToolTypes(
                      duplicateComToolTypes ? false : true
                    );
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  checked={duplicatePrestataires}
                  readOnly
                  label="Dupliquer les prestataires"
                  onClick={() => {
                    setDuplicatePrestataires(
                      duplicatePrestataires ? false : true
                    );
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  checked={duplicateKams}
                  readOnly
                  label="Dupliquer les kams"
                  onClick={() => {
                    setDuplicateKams(duplicateKams ? false : true);
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  checked={duplicateAmbassadrices}
                  readOnly
                  label="Dupliquer les ambassadrices"
                  onClick={() => {
                    setDuplicateAmbassdrices(
                      duplicateAmbassadrices ? false : true
                    );
                  }}
                />
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="is-bottom-right">
          <Button
            variant="secondary"
            onClick={() => {
              handleClose();
            }}
          >
            Annuler
          </Button>
          <Button variant="success" type="submit">
            Valider
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
